export default "__VITE_ASSET__d1e43387__"